import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation StartCustomerSubscription(
    $customerId: ID!
    $plan: String!
    $wordsTier: String
    $stripePaymentMethodId: ID!
    $promotionCode: String
    $billingCycle: BillingCyclePeriod
  ) {
    startCustomerSubscription(
      customerId: $customerId
      plan: $plan
      wordsTier: $wordsTier
      stripePaymentMethodId: $stripePaymentMethodId
      promotionCode: $promotionCode
      billingCycle: $billingCycle
    ) {
      status
      latestInvoice {
        paymentIntentStatus
        paymentIntentClientSecret
      }
      customer {
        stripeCustomerId
      }
    }
  }
`;

export const startCustomerSubscription = (
  customerId,
  plan,
  tier,
  stripePaymentMethodId,
  promotionCode,
  billingCycle
) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      plan,
      wordsTier: tier,
      stripePaymentMethodId,
      promotionCode,
      billingCycle,
    },
  }).then(({ data }) => getSingleProp(data));
